<!-- 📁 src/components/DetailItem.vue -->
<template>
  <div class="detail-item">
    <i :class="icon"></i>
    <strong>{{ label }}:</strong>
    <span>{{ value || $t('competitions.view.not_defined') }}</span>
  </div>
</template>

<script>
export default {
  name: "DetailItem",
  props: {
    label: { type: String, required: true },
    value: { type: [String, Number,Array], default: '' },
    icon: { type: String, default: "fa-solid fa-info-circle" } // Icono por defecto
  }
};
</script>

<style scoped>
.detail-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}
.detail-item i {
  color: #5b5b5b;
  font-size: 16px;
}
</style>
